import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.dispatch_event = function() {
  document.dispatchEvent(
    new CustomEvent(
      this.getAttribute('name'),
      {
        detail: JSON.parse(this.getAttribute('detail') || {}),
      },
    ),
  )
}
